/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsupcominghint2Inputs */

const en_statsupcominghint2 = /** @type {(inputs: Statsupcominghint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans not expired, dated today or later or without a date.`)
};

const de_statsupcominghint2 = /** @type {(inputs: Statsupcominghint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht abgelaufene Pläne ab heute oder ohne Datum.`)
};

/**
* | output |
* | --- |
* | "Plans not expired, dated today or later or without a date." |
*
* @param {Statsupcominghint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsupcominghint2 = /** @type {((inputs?: Statsupcominghint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsupcominghint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsupcominghint2(inputs)
	return de_statsupcominghint2(inputs)
});
export { statsupcominghint2 as "statsUpcomingHint" }